/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.Utils.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.Cart.d.ts" />

import * as React from "react";
import {observer} from "mobx-react";

import './widget.scss';

import appstate, { IAppMode } from "../../appstate";
import {Datepicker} from "../datepicker/datepicker";

export interface IAppProps {
    roomTypeCodeFilter?: string,
    promotionCode?: string,
    ratePlanOrGroupCode?: string,
    rate?: string,
    showPriceCalendar?: boolean,
    showTotalPrice?: boolean,
    hidePromotionCode: boolean,
    adults?: number,
    showCampaignCodeInline?: boolean,
    action?: string,
    startDate?: string,
    endDate?: string
}

export interface IAppState {
    isOffline: boolean,
}

@observer
export class Widget extends React.Component<IAppProps, IAppState> {
    constructor(props: IAppProps) {
        super(props);

        appstate.promotionCode = props.promotionCode;
        appstate.ratePlanOrGroupCode = props.ratePlanOrGroupCode;
        
        if (this.props.startDate != null && this.props.endDate != null) {
            appstate.startDate = new Date(Date.parse(this.props.startDate));
            appstate.endDate = new Date(Date.parse(this.props.endDate));
        }

        appstate.setAppMode(IAppMode.Widget);

        this.state = {
            isOffline: false,
        }

        appstate.isNonRoom = false;
        appstate.reservations[0].Rooms[0].Guests[0].Count = (this.props.adults != null) ? this.props.adults : NCB.Settings.HotelProperties.DefaultNumberOfAdults;

        this.initialize();

        NCB.Utils.checkBackendStatus(() => {
            this.setState({
                isOffline: true
            });

            if (!document.body.classList.contains("ncb-widget-is-offline"))
                document.body.classList.add("ncb-widget-is-offline");
        });

        NCB.Log.metric("Widget Created", 1);
    }

    initialize() {
        this.forceUpdate();

        if (!document.body.classList.contains("ncb-widget-is-loaded"))
            document.body.classList.add("ncb-widget-is-loaded");
    }

    setCalendar = (startDate: Date, endDate: Date, showCalendar?: boolean, promotionCode?: string, rooms?: CC.Library.Models.Calendar.NcbCalendarRoom[], ratePlanOrGroupCode?: string)  => {

        if (showCalendar) {

            appstate.startDate = startDate;
            appstate.endDate = endDate;

            if (rooms != null) {
                rooms.forEach((room, i) => {
                    appstate.reservations[i].Rooms[0].Guests = room.Guests;
                });  
            }

        } else {

            let childAges: string = "";
            if (NCB.Settings.UseChildAges) {
                rooms.forEach(r => {
                    let filteredChildren = r.Guests.filter(x => x.GuestType === CC.Library.Models.Shared.GuestType.Child);
                    if (filteredChildren.length > 0)
                        childAges += "&ages=" + filteredChildren.map(x => x.Age).join("_");
                    else 
                        childAges += "&ages=0";
                });
            }

            document.location.href = NCB.Settings.BookingStartURL + 
                                     "?startDate=" + NCB.DateUtils.getISODate(startDate) + 
                                     "&endDate=" + NCB.DateUtils.getISODate(endDate) + 
                                     "&roomTypeCode=" + (this.props.roomTypeCodeFilter == null ? "" : this.props.roomTypeCodeFilter) + 
                                     "&promotionCode=" + (promotionCode == null  ? "" : promotionCode) + 
                                     "&ratePlanOrGroupCode=" + (ratePlanOrGroupCode == null ? "" : ratePlanOrGroupCode) +
                                     "&rate=" + (this.props.rate == null  ? "" : this.props.rate + "&gotoRoom=1") + 
                                     "&" + rooms.map(x => "room=" + NCB.Utils.getNumAdults(x.Guests) + "_" + NCB.Utils.getNumChildren(x.Guests)).join("&") + 
                                     childAges + "&fromwidget=1";
        }
    }

    render() {
        if (!this.state.isOffline) {
            
            let gc: CC.Library.Models.Calendar.NcbCalendarRoom[] = [];
            appstate.reservations.forEach(r => {
                gc.push({
                    Guests: r.Rooms[0].Guests
                });
            });

            return <Datepicker 
                    onSetCalendar={this.setCalendar}
                    startDate={appstate.startDate}
                    endDate={appstate.endDate}
                    guestCount={gc}
                    promotionCode={appstate.promotionCode}
                    ratePlanOrGroupCode={appstate.ratePlanOrGroupCode}
                    roomTypeCodeFilter={this.props.roomTypeCodeFilter}
                    limitGuestSelection={true}
                    showPriceCalendar={this.props.showPriceCalendar || false}
                    showTotalPrice={this.props.showTotalPrice || false}
                    hidePromotionCode={this.props.hidePromotionCode}
                    showCampaignCodeInline={this.props.showCampaignCodeInline}
                    showStartDateWidget={this.props.action === 'start_date'}
                    showEndDateWidget={this.props.action === 'end_date'} 
                    isModalOpen={this.props.action === 'add_code'}
                    isGuestSelectorOpen={this.props.action === 'show_simple_guest_selector'}/>;
        } else {
            return <div></div>
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/widget.tsx